import React from 'react';

import PropType from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import style from './style.module.less';

const NullStateOverlay = ({ classname }) => {
  return (
    <div className={classnames(style['overlay-container'], classname)}>
      <div className={style['overlay-pill']}>
        <FormattedMessage
          defaultMessage='Insufficient Data'
          description='A message that gets displayed over a graph when there is not enough data'
          id='ZLrIcm'
        />
      </div>
    </div>
  );
};

NullStateOverlay.propTypes = {
  classname: PropType.string,
};

export default NullStateOverlay;
